<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LANG_NAMES } from '@kidzonet/consts'
import { AVALIABLE_LANGUAGES } from '@kidzonet/vue-i18n-package'

import LanguageSelectorItem from './Item.vue'

const { t, locale } = useI18n()

const avaliableLanguages = computed(() => AVALIABLE_LANGUAGES.map(value => ({
    title: t(`common.language_selector.${value}`),
    value,
    original: LANG_NAMES[value],
})).sort((a, b) => {
    if (a.title < b.title) {
        return -1
    }
    return 1
}))

const model = ref(locale.value)

const changeLanguage = () => {
    localStorage.setItem('locale', String(model.value))
    window.location.reload()
}
</script>

<template>
    <v-select
        v-model="model"
        @update:model-value="changeLanguage"
        class="language-selector"
        :items="avaliableLanguages"
        variant="underlined"
        close-text="close language selector"
        open-text="open language selector"
        :label="t('web_common.account.settings.language_select')"
    >
        <template #item="data">
            <v-list-item
                v-bind="data.props"
                :key="data.item.value"
                :value="data.item.value"
                :title="data.item.title"
                :subtitle="data.item.original"
            >
                <template #subtitle>
                    <span :lang="data.item.value">
                        {{ data.item.original }}
                    </span>
                </template>
            </v-list-item>
        </template>
        <template #selection="{ item }">
            <LanguageSelectorItem
                :title="item.title"
            />
        </template>
    </v-select>
</template>

<style>
    .language-selector {
        align-self: stretch;
    }
</style>
